var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9438_116037)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.80469,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 11.8002C14.0002 12.3212 13.7895 12.8208 13.4145 13.1892C13.0394 13.5576 12.5307 13.7645 12.0002 13.7645C11.4698 13.7645 10.9611 13.5576 10.586 13.1892C10.211 12.8208 10.0002 12.3212 10.0002 11.8002C10.0002 11.2793 10.211 10.7796 10.586 10.4113C10.9611 10.0429 11.4698 9.83594 12.0002 9.83594C12.5307 9.83594 13.0394 10.0429 13.4145 10.4113C13.7895 10.7796 14.0002 11.2793 14.0002 11.8002Z",
    stroke: "#A8A8A8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33374 11.8021C6.40041 9.11952 8.89107 7.21875 12.0004 7.21875C15.1097 7.21875 17.6004 9.11952 18.6671 11.8021C17.6004 14.4846 15.1097 16.3854 12.0004 16.3854C8.89107 16.3854 6.40041 14.4846 5.33374 11.8021Z",
    stroke: "#A8A8A8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9438_116037",
    x: 0.333333,
    y: 0.138021,
    width: 23.3333,
    height: 23.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.833333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9438_116037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9438_116037",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLight);
export default __webpack_public_path__ + "static/media/eye-light.dc264d139b59b31ce569b5c87efd3119.svg";
export { ForwardRef as ReactComponent };